/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyBatchRequest {
    getFixupPrototypeFunction() { return PolicyBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyBatchRequest>): PolicyBatchRequest {
        let obj = Object.assign(new PolicyBatchRequest(), model);
        PolicyBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyBatchRequest>): PolicyBatchRequest {
        if (!model) return null;
        return PolicyBatchRequest.newInstance(<PolicyBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyBatchRequest) {
        if (!obj) return;

        models.PolicyBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyBatchRequest): boolean {
        Object.setPrototypeOf(obj, PolicyBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique identifiers of the policies
     */
    ids: Array<string>;

    /**
     * list of policy uris of the policies
     */
    uris: Array<string>;

}
